// C:\Projects\texe\texe-web\src\routes\AdminRoute.tsx
import type { ReactNode } from "react";
import { useAuth } from "../context/AuthProvider";

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: 24 }}>Yükleniyor...</div>;
  }

  if (!user) {
    // Giriş koruması ProtectedRoute'ta da var ama
    // burada da güvenli tarafta kalalım.
    return (
      <div style={{ padding: 24 }}>
        <h2>Bu sayfaya erişilemiyor</h2>
        <p>Devam etmek için giriş yapmalısın.</p>
      </div>
    );
  }

  if (!(user as any)?.isAdmin) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Bu sayfaya erişilemiyor</h2>
        <p>Bu alan sadece yetkili (admin) kullanıcılar içindir.</p>
      </div>
    );
  }

  return <>{children ?? null}</>;
}
